










/* ----------------------------------------
    Imports
---------------------------------------- */

import { Component, Vue } from 'vue-property-decorator';
import StepMixin from '@mixin/step';

/* ----------------------------------------
    Component
---------------------------------------- */

@Component({
    data() {
        return {
            prev: false,
            autosave: false,
        };
    },

    mixins: [
        StepMixin,
    ],
})

/* ----------------------------------------
    Export
---------------------------------------- */

export default class Intro extends Vue {}

